// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"nC-z","smallCardRow":"oC-z","largeCardRow":"pC-z","productSearchRow":"qC-z","curatedRow":"rC-z"};